import { render } from "./air-quality-report-lift.vue?vue&type=template&id=31186292"
import script from "./air-quality-report-lift.vue?vue&type=script&lang=js"
export * from "./air-quality-report-lift.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__